import { render, staticRenderFns } from "./DeactivateUser.vue?vue&type=template&id=2a616eb5&scoped=true&"
import script from "./DeactivateUser.vue?vue&type=script&lang=js&"
export * from "./DeactivateUser.vue?vue&type=script&lang=js&"
import style0 from "./DeactivateUser.vue?vue&type=style&index=0&id=2a616eb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a616eb5",
  null
  
)

export default component.exports